import { GetResources } from "./scripts/ResourceManager.js";
import { PublicClientApplication } from "@azure/msal-browser";

const resources = GetResources();
export const msalConfig = {
    auth: {
        clientId: 'e27d4635-b87c-411a-bfef-d2a4dd2cbb8e',
        authority: 'https://login.microsoftonline.com/36da45f1-dd2c-4d1f-af13-5abe46b99921',
        redirectUri: 'https://cleverantdownload.deloitte.ca/'
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// export const loginRequest = {
//     //scopes: ["User.Read"]
//     scopes: ['https://cleverantdownload.deloitte.ca/user_impersonation']
// };
export const msalInstance = new PublicClientApplication(msalConfig);
// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf?$top=500" //e.g. https://graph.microsoft.com/v1.0/me
// };

// export const adalConfigOptions = fetch('api/admin/Admin/GetAdalConfig').then(response => response.json())
//     .then(config => {      
//         config.redirectUri = window.location.origin;
//         config.postLogoutRedirectUri = window.location.origin;
//         // var authContext = new AuthenticationContext(config);
//         // var adalApiFetch = (fetch, url, options) =>
//         //     adalFetch(authContext, config.endpoints.api, fetch, url, options);
//         // var withAdalLoginApi = withAdalLogin(authContext, config.endpoints.api);
//         //var withAdalLoginApi = msalInstance.loginRedirect(loginRequest);
//         const msalApiFetch="";
//         var configValues = {
//             msalConfig : config,
//             // authContext: authContext,
//              msalApiFetch: msalApiFetch,
//             // withAdalLoginApi: withAdalLogin(authContext, config.endpoints.api),
//             // withAdalLoginApi: msalInstance.loginRedirect(loginRequest),

//             authGroup: config.authGroup
//         }
//         return configValues;
//     });

    
    

//export const adalConfig = {
//    tenant: '36da45f1-dd2c-4d1f-af13-5abe46b99921',
//    clientId: '1a4b6c33-ae71-436d-a9a8-a1904fca83ed',
//    endpoints: {
//        // api: 'https://localhost:44323',
//        api: 'https://graph.microsoft.com'
//    },
//    redirectUri: window.location.origin,
//    // redirectUri: 'https://localhost:44342',
//    postLogoutRedirectUri: window.location.origin,
//    cacheLocation: 'localStorage',
//};

//export const authContext = new AuthenticationContext(adalConfig);

//export const adalApiFetch = (fetch, url, options) =>
//    adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

//export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);
